import { Expose } from 'class-transformer';
import { Model } from './model';
import { DashboardTypes } from '@shared/enums/dashboard-types.enum';

export class Dashboard extends Model {
  @Expose() url: string;
  @Expose() name: string;
  @Expose() type: DashboardTypes;
}
